import React from 'react';
import { motion } from 'framer-motion';
import { workExperience } from '../data/siteData';

const ProfessionalExperience = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="experience" className="experience-standalone-section">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2>Professional Experience</h2>
          <p>Career timeline and engineering roles</p>
        </motion.div>
          {/* Experience Timeline */}
          <motion.div
            className="experience-section"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div className="timeline">
              {workExperience.map((exp, index) => (
                <motion.div
                  key={index}
                  className="timeline-item"
                  variants={itemVariants}
                  whileHover={{ x: 10 }}
                  transition={{ type: "spring", stiffness: 300, damping: 10 }}
                >
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <span className="timeline-period">{exp.period}</span>
                    <h3>{exp.title}</h3>
                    <span className="timeline-company">{exp.company}</span>
                    <p>{exp.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
      </div>
    </section>
  );
};
export default ProfessionalExperience;
